import { DI } from 'modules'
import React from 'react'
import { ShareDropdown, ShareList } from './share'

function ShareView({
  titleOfStr = '',
  entity = {},
  common = {},
  alignLeft = false,
}) {
  return (
    <div className="live-share">
      {/* <span className="live-share__title">
                {common.strings[titleOfStr]}
            </span> */}
      <ShareList entity={entity} />
      <ShareDropdown
        title={common.strings[titleOfStr]}
        entity={entity}
        styled
        alignLeft={alignLeft}
      />
    </div>
  )
}

export default DI(['common'])(ShareView)
